import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/comingSoon.css';

const ComingSoon = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('programme');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  useEffect(() => {
    // Extract which page was clicked from URL
    const path = location.pathname.toLowerCase();
    if (path.includes('speakers')) setActiveTab('speakers');
    else if (path.includes('xp')) setActiveTab('xp');
    else setActiveTab('programme');
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Please enter your email');
      return;
    }
    
    setIsSubmitting(true);
    setMessage('');
    
    try {
      const response = await fetch('https://enerygx-backend.onrender.com/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          interest: content[activeTab].title
        }),
      });
      
      const data = await response.json();
      if (data.success) {
        setMessage(data.message);
        setEmail('');
      } else {
        setMessage(data.message || 'Subscription failed. Please try again.');
      }
    } catch (error) {
      setMessage('Network error. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const content = {
    programme: {
      title: "Programme",
      description: "We're crafting an inspiring lineup of sessions and speakers for EnergyX Africa 2025. Check back soon for the full schedule!",
      icon: "📅"
    },
    speakers: {
      title: "Speakers",
      description: "Want to share your expertise at EnergyX Africa? Our speaker application portal will open soon. Stay tuned!",
      icon: "🎤"
    },
    xp: {
      title: "EnergyX Africa XP",
      description: "An immersive experience is coming! Be the first to know about our interactive sessions and networking opportunities.",
      icon: "✨"
    }
  };

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-card">
        <div className="icon-circle">{content[activeTab].icon}</div>
        <h1>{content[activeTab].title} Coming Soon</h1>
        <p>{content[activeTab].description}</p>
        
        <div className="progress-container">
          <div className="progress-bar"></div>
        </div>
        
        <form className="notify-form" onSubmit={handleSubmit}>
          <input 
            type="email" 
            placeholder="Enter your email for updates" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
          />
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Notify Me'}
          </button>
        </form>
        
        {message && <div className="subscription-message">{message}</div>}
        
        <div className="social-links">
          <a href="https://x.com/EnergyxAfrica"><span>Twitter</span></a>
          <a href="https://www.linkedin.com/company/experience-energyx-africa/?originalSubdomain=za"><span>LinkedIn</span></a>
          <a href="https://www.instagram.com/energyx.africa/"><span>Instagram</span></a>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;